var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with (null).")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-up",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.359375,31.9453125 C45.8125023,32.4765652 45.8945327,33.0351533 45.6054688,33.6210938 C45.3164048,34.2070342 44.8359409,34.5 44.1640625,34.5 L4.5546875,34.5 C3.88280914,34.5 3.42578246,34.2070342 3.18359375,33.6210938 C2.94140504,33.0351533 3.04687273,32.4765652 3.5,31.9453125 L22.109375,11.390625 C22.703128,10.7187466 23.4531205,10.3828125 24.359375,10.3828125 C25.2656295,10.3828125 26.015622,10.7187466 26.609375,11.390625 L45.359375,31.9453125 Z",
    id: "directup"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectUp);
export default __webpack_public_path__ + "static/media/direct-up.815651f6cbdce1dfbb193f628efab579.svg";
export { ForwardRef as ReactComponent };